import React from "react";

export default function Arrows({
  prevTopic,
  singleScreenStep,
  singleScreenStepLength,
  isSingleStepScreen,
  simPageNum,
  isEmulatorStep,
  emulatorStep,
  setSingleScreenStep,
  setEmulatorStep,
  setSimPageNum,
  setPage,
  switchScreens,
  totalSteps,
}) {
  return (
    <div className="arrows">
      <img
        alt="arrow left"
        src="./images/arrow-right.svg"
        style={{
          transform: "rotate(180deg)",
          height: "80px",
          width: "auto",
          opacity: "0.4",
        }}
        onClick={() => {
          if (isEmulatorStep && emulatorStep > 0) {
            setEmulatorStep((prevState) => {
              prevState--;

              return prevState;
            });
          } else if (isSingleStepScreen && singleScreenStep > 0) {
            if (simPageNum !== 0) {
              setSimPageNum(0);
            } else {
              setSingleScreenStep((prevState) => {
                prevState--;

                return prevState;
              });
            }
          } else if (simPageNum > 0) {
            setSimPageNum((prevState) => {
              prevState--;

              return prevState;
            });
          } else {
            setPage(prevTopic);
          }
        }}
      />
      <img
        id="real-next-arrow"
        alt="arrow right"
        src="./images/arrow-right.svg"
        style={{
          margin: "0 0 0 40px",
          height: "80px",
          width: "auto",
          opacity: "0.8",
        }}
        onClick={() => {
          switchScreens();
        }}
      />
      <img
        alt="arrow right"
        src="./images/arrow-right.svg"
        style={{
          margin: "0 0 0 -64px",
          height: "80px",
          width: "auto",
          opacity: "0.8",
          animation:
            !isEmulatorStep || (isEmulatorStep && emulatorStep > totalSteps - 2)
              ? "1.5s infinite pulse"
              : null,
          pointerEvents: "none",
          zIndex: "299",
        }}
      />
    </div>
  );
}
